/* eslint-disable react/require-default-props */
import React from 'react';
import LetterAvatar from '@components/Avatar/LetterAvatar';
import { Button, Tooltip } from '@ui';
import Chip from '@components/Chip/chip';
import StatusIcon from '@components/StatusIcon/StatusIcon';
import ImageAvatar from '@components/Avatar/ImageAvatar';
import UiSizes from '@enums/UiSizes';
import { translate } from '@utils/i18n';
import camelToCapitalize from '@utils/functions/camelToCapitalize';
import { IndexNamespace } from '../../constants';
import dateFormatter from '../../utils/dateFormatter';
import getStatusUpdate from '../../utils/getStatusUpdate';
import getVersionDetails from '../../utils/getVersionDetails';
import versionEventLabels from '../../utils/versionEventLabels';
import useFilters from '../../hooks/useFilters';
import VersionDetails from './VersionDetails';
function authorByline(name) {
    if (!name)
        return '';
    return ` ${translate('by_author', { namespace: IndexNamespace, name })}`;
}
function StatusUpdateComp({ prev, new: newStatus, itemType, authorName }) {
    if (!prev || !newStatus) {
        return null;
    }
    const statusChangedFrom = translate(itemType === 'Visit' ? 'visit_status_changed_from' : 'status_changed_from', {
        namespace: IndexNamespace
    });
    return (React.createElement(React.Fragment, null,
        React.createElement("span", null, statusChangedFrom),
        prev && React.createElement(Chip, { icon: React.createElement(StatusIcon, { status: prev }), label: prev.label }),
        React.createElement("span", null, translate('to', { namespace: IndexNamespace })),
        newStatus && React.createElement(Chip, { icon: React.createElement(StatusIcon, { status: newStatus }), label: newStatus.label }),
        authorName ? React.createElement("span", null, authorByline(authorName)) : null));
}
export default function Version({ version }) {
    var _a;
    const { data } = useFilters();
    // Initialize local state based on global preference
    const [showDetails, setShowDetails] = React.useState((data === null || data === void 0 ? void 0 : data.showDetails) === 'expanded');
    const detailsToShow = getVersionDetails(version);
    // Update local state when global preference changes
    React.useEffect(() => {
        setShowDetails((data === null || data === void 0 ? void 0 : data.showDetails) === 'expanded');
    }, [data === null || data === void 0 ? void 0 : data.showDetails]);
    const statusUpdate = getStatusUpdate(version);
    const infoText = statusUpdate ? (React.createElement(StatusUpdateComp, { prev: statusUpdate[0], new: statusUpdate[1], itemType: version.itemType, authorName: version.author.name })) : (`${camelToCapitalize(version.itemType)} ${(_a = versionEventLabels[version.event]) !== null && _a !== void 0 ? _a : ''}${authorByline(version.author.name)}`);
    const avatar = (React.createElement("span", null,
        version.author.avatar && (React.createElement(ImageAvatar, { src: version.author.avatar, borderColor: version.author.color || '#bbb', size: UiSizes.medium })),
        version.author.name && !version.author.avatar && (React.createElement(LetterAvatar, { letter: version.author.name[0], backgroundColor: version.author.color || '#bbb', size: UiSizes.medium })),
        !version.author.name && !version.author.avatar && !version.author.type && (React.createElement("span", { className: `qmb-avatar--${UiSizes.medium}`, style: {
                backgroundColor: '#bbb',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            } },
            React.createElement("i", { className: "fa-solid fa-users-gear", style: { color: '#fff' } })))));
    return (React.createElement("div", { className: "activity__item versionContainer" },
        React.createElement("div", { className: "versionContent" },
            React.createElement("div", { className: "versionAvatarContainer" }, version.author.name ? React.createElement(Tooltip, { content: version.author.name }, avatar) : avatar),
            React.createElement("div", { className: "versionInfoContainer" },
                React.createElement("span", null, infoText),
                detailsToShow.length > 0 && (React.createElement(Button, { variant: "default", onClick: () => {
                        setShowDetails(!showDetails);
                    } }, translate(showDetails ? 'hide_details' : 'show_details', { namespace: IndexNamespace })))),
            React.createElement("div", { className: "activity__date" },
                React.createElement(Tooltip, { content: new Date(version.createdAt).toLocaleString() },
                    React.createElement("span", null, dateFormatter(new Date(version.createdAt)))))),
        showDetails && React.createElement(VersionDetails, { details: detailsToShow, version: version })));
}
